/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Speciallist_Combatstrong2Inputs */

const id_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertarungan Dinamis`)
};

const ms_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertarungan Dinamik`)
};

const da_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamisk Kamp`)
};

const de_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamischer Kampf`)
};

const en_us2_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic Combat`)
};

const es_es2_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combate dinámico`)
};

const es_mx2_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combate dinámico`)
};

const fil_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic na Labanan`)
};

const fr_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combat dynamique`)
};

const it_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combattimento dinamico`)
};

const hu_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamikus harc`)
};

const nl_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamische gevechten`)
};

const no_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamisk kamp`)
};

const pl_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamiczna walka`)
};

const pt_br2_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combate Dinâmico`)
};

const pt_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combate dinâmico`)
};

const ro_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luptă dinamică`)
};

const fi_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynaaminen taistelu`)
};

const sv_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamisk strid`)
};

const vi_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiến đấu năng động`)
};

const tr_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamik Savaş`)
};

const cs_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamický boj`)
};

const bg_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамичен бой`)
};

const ru_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамичный бой`)
};

const uk_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамічний бій`)
};

const ar_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قتال ديناميكي`)
};

const hi_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गतिशील युद्ध`)
};

const th_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การต่อสู้ที่ไดนามิก`)
};

const ja_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイナミックな戦闘`)
};

const zh_cn2_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态战斗`)
};

const zh_hant1_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動態戰鬥`)
};

const ko_misc_posts_speciallist_combatstrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Combatstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다이나믹 전투`)
};

/**
* | output |
* | --- |
* | "Dynamic Combat" |
*
* @param {Misc_Posts_Speciallist_Combatstrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_combatstrong2 = /** @type {((inputs?: Misc_Posts_Speciallist_Combatstrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Combatstrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "da") return da_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "de") return de_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "it") return it_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "no") return no_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "th") return th_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_combatstrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_combatstrong2(inputs)
	return ko_misc_posts_speciallist_combatstrong2(inputs)
});
export { misc_posts_speciallist_combatstrong2 as "misc.posts.specialList.combatStrong" }